import { CEST } from "../models/central-operacional";
import { FiltroDashboard } from "../models/filtro-dashboard";
import { FiltroLaudo } from "../models/filtros/filtro-laudo";
import api from "../services/api-gateway";

interface Params {
	pagina: number;
	quantidade: number;
	codAgenciaJurisdicao?: number;
	codAgenciaSolicitante?: number;
	codTipoCaracteristica?: number[];
	excluiCanceladas?: boolean;
	excluiAlocado?: boolean;
	exclusaoLaudoId?: number[];
	limitarValor?: boolean;
	cest?: CEST;
	filtroLaudo?: FiltroLaudo;
}

export async function getListaLaudoPaginado(value: Params): Promise<any> {
	return api.post(`/s610-gateway-servico/v1/laudos/${value.pagina}/${value.quantidade}`, {
		codAgenciaJurisdicao: value.codAgenciaJurisdicao,
		codAgenciaSolicitante: value.codAgenciaSolicitante,
		codTipoCaracteristica: value.codTipoCaracteristica,
		codSituacao: value.filtroLaudo ? value.filtroLaudo.fase : null,
		excluiCanceladas: value.excluiCanceladas,
		excluiAlocado: value.excluiAlocado,
		exclusaoLaudoId: value.exclusaoLaudoId,
		limitarValor: value.limitarValor,
		codigosUfs: value.cest ? value.cest.codigosUfs : null,
		codigoSiatSistec: value.filtroLaudo ? value.filtroLaudo.codigoSiatSistec : null,
		sicadCpfCnpjCliente: value.filtroLaudo ? value.filtroLaudo.sicadCpfCnpjCliente : null,
		nomeCliente: value.filtroLaudo ? value.filtroLaudo.nomeCliente : null,
		dataInicial: value.filtroLaudo ? value.filtroLaudo.dataInicial : null,
		dataFinal: value.filtroLaudo ? value.filtroLaudo.dataFinal : null,
		codsLaudos: value.filtroLaudo ? value.filtroLaudo.codsLaudos : null,
		mesAno: value.filtroLaudo ? value.filtroLaudo.mesAno : null,
		ano: value.filtroLaudo ? value.filtroLaudo.ano : null,
		codsSituacoes: value.filtroLaudo ? value.filtroLaudo.codsSituacoes : null,
		codsTipoLaudo: value.filtroLaudo && value.filtroLaudo.codsTipoLaudo && value.filtroLaudo.codsTipoLaudo.length > 0 ? value.filtroLaudo.codsTipoLaudo : null,
	});
}

export async function getSituacoesLaudo(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/laudos/situacoes");
}

export async function obterSolicitacaoLaudo(codLaudo: number): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudos/${codLaudo}`);
}

export async function getMovimentacoes(codigoLaudo: number): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/laudos/${codigoLaudo}/movimentacoes`);
}

export async function consultarVersaoLaudo(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/laudos/versao-laudo");
}

export async function obterPrazos(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/laudos/dashboard/prazos");
}

export async function obterDesempenho(filtro: FiltroDashboard): Promise<any> {
	return api.post("/s610-gateway-servico/v1/laudos/dashboard/desempenho", filtro);
}

export async function getTiposLaudosEstadosAgencias(isEdicao: boolean): Promise<any> {
	return api.get(`/s610-gateway-servico/v1/dominios/tiposLaudo?edicao=${isEdicao}`);
}

export async function obterDesempenhoGeral(filtro: FiltroDashboard): Promise<any> {
	return api.post("/s610-gateway-servico/v1/laudos/dashboard/desempenho-geral", filtro);
}

